import apiClient from '../api/apiClient';

const UTILITY_SHARE_TRANSFER = '/api/v1/utility/sharetransfer/extraction';
const ADMIN_MATCH = '/api/v1/admin/orders/share-transfer/match';
const ADMIN_BULK_TRANSFER = '/api/v1/admin/orders/share-transfer/bulk-transfer';

const OCR_TIMEOUT_MS = 900000;

const multipartConfig = {
  timeout: OCR_TIMEOUT_MS,
  headers: {
    'Content-Type': false,
  },
};

const unwrap = (response) => response.data?.data ?? response.data;

export async function extractShareTransferPdf(file) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.request({
    method: 'POST',
    url: UTILITY_SHARE_TRANSFER,
    data: formData,
    ...multipartConfig,
  });

  return response.data;
}

export async function matchShareTransfers(extractions) {
  const response = await apiClient.post(ADMIN_MATCH, { extractions });
  return unwrap(response);
}

export async function bulkTransferShares(transfers) {
  const response = await apiClient.post(ADMIN_BULK_TRANSFER, { transfers });
  return unwrap(response);
}

export default {
  extractShareTransferPdf,
  matchShareTransfers,
  bulkTransferShares,
};
